import { useMemo } from "react"
import { useLink } from "../../hooks"

export const usePressSchema = ({
  headline,
  datePublished,
  image,
  authorName,
  authorURL,
}: {
  headline: string
  datePublished: string
  image?: string
  authorName?: string
  authorURL
}) => {
  return useMemo(() => {
    if (!headline || !datePublished) return null

    return {
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      headline: headline,
      datePublished: new Date(datePublished).toISOString(),
      ...(image && { image: image }),
      ...(authorName && {
        author: {
          "@type": "Person",
          name: authorName,
          url: `${useLink(authorURL)}`,
        },
      }),
    }
  }, [headline, datePublished, image, authorName, authorURL])
}
